export const FAULTCODE_USERNAME = 'validation.username';
export const FAULTCODE_RESET_IN_PROGRESS = 'validation.resetInProgress';
export const FAULTCODE_USERNAME_EXISTS = 'validation.userNameExists';
export const FAULTCODE_BIRTH = 'validation.birth';
